export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f851fc18c5dac5e662a7c3aaa8a8a3b9bc0455097&name=fetchTypeahead!'